oyc.PodloveWebPlayer = {
  selector: {
    container: '.podcast-player',
  },

  container: null,
  init: function () {
    this.container = $(this.selector.container);
    if (0 < this.container.length) {
      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Async/podlove-web-player/embed.js')
        .then(function () {
          console.log('oyc.PodloveWebPlayer.init - asset loaded');
          if (location.origin.match('localhost')) {
            window.podlovePlayer('#Broadcastplayer', '/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Json/episode.json', '/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Json/config.json').then(
              oyc.PodloveWebPlayer.adjustOptics.bind(oyc.PodloveWebPlayer, document.querySelector('#Broadcastplayer'))
            );
          } else {
            this.container.each(this.initPlayer.bind(this))
          }
        }.bind(this));
    }
  },
  initPlayer: function (i, container) {
    console.log('oyc.PodloveWebPlayer.initPlayer', i, container);
    if (container.id in oyc.static.PodloveWebPlayer) {
      window.podlovePlayer(
        container,
        oyc.static.PodloveWebPlayer[container.id].configEpisode,
        oyc.static.PodloveWebPlayer[container.id].configPlayer
      ).then(oyc.PodloveWebPlayer.adjustOptics.bind(oyc.PodloveWebPlayer, container));
    }
  },
  /**
   * called after the iframe is initialized but possibly it's contents are built
   * so we wait for a specific element inside before we this.replaceIcons
   * @param {HTMLElement} container
   * @param {Redux} store
   */
  adjustOptics: function (container, store) {
    console.log('oyc.PodloveWebPlayer.adjustOptics', container, store);
    if (container.childNodes[0]) {
      this.replaceIcons(container.childNodes[0])

    } else {
      this.waitForIFrame(container).then(this.replaceIcons.bind(null, container.childNodes[0]))
    }
  },
  /**
   *
   * @param {HTMLElement} parentElement
   * @returns {Promise}
   */
  waitForIFrame: function (parentElement) {
    console.log('wait for iframe', parentElement, parentElement.childNodes);
    return oyc.waitForElement(parentElement.id + '>iframe #play-button--play');
  },
  /**
   * function to replace the icon markup
   * @param {HTMLElement} iframe
   */
  replaceIcons: function (iframe) {
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.type = 'text/css';
    cssLink.href = '/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Css/Async/podlove-players.css';

    // ensure we really have an iframe
    if ('contentDocument' in iframe) {
      iframe.contentDocument.head.appendChild(cssLink);
    }
  }
}
